'use strict';

var fs = require('fs');

var _require = require('path'),
    resolve = _require.resolve,
    join = _require.join;

/**
 * Get files
 * @param {string} root
 * @returns {string[]}
 */


var getFiles = function getFiles(root) {
  var result = [];
  fs.readdirSync(root).forEach(function (file) {
    var path = join(root, file);
    var stat = fs.statSync(path);
    if (!stat.isDirectory()) {
      result.push(file);
    } else {
      result = result.concat(getFiles(path).map(function (f) {
        return join(file, f);
      }));
    }
  });
  return result.filter(function (file) {
    return file.endsWith('.js') && !file.endsWith('.inspect.js') && !file.endsWith('.original.js');
  });
};

/**
 * Get files
 * @param {string} root
 * @param {boolean} [shouldResolve=true]
 * @returns {string[]}
 */
exports.getFiles = function (root) {
  var shouldResolve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var files = getFiles(root);
  if (shouldResolve) files = files.map(function (file) {
    return resolve(root, file);
  });
  return files;
};

/**
 * Flatten
 * @param {string[][]} arrays
 * @returns {string[]}
 */
exports.flatten = function (arrays) {
  return [].concat.apply([], arrays);
};


//////////////////
// WEBPACK FOOTER
// ../lib/helpers.js
// module id = 173
// module chunks = 0